import { useState, useContext, useEffect } from "react"
import { gql, useQuery } from "@apollo/client"
import { useParams } from "react-router-dom" // Importa useParams para capturar los parámetros de la URL
import _ from "lodash"

import { Field } from "formik"
import { Dropdown } from "primereact/dropdown"
import { useFormikContext } from "formik"
import { UserContext } from "../../../context/userContext"
import { FormContext } from "../../../context/formContext"

import styles from "../../../styles/Form.module.css"

export default function StaffOrganizationId({ field, block, index }) {
  const formik = useFormikContext()
  const [disable, setDisable] = useState(false)
  const [organizationList, setOrganizationList] = useState([])
  const userCtx = useContext(UserContext)
  const form = useContext(FormContext)

  const { type } = useParams()

  const isEnterprise = type === "enterprise"
  const isOrganization = type === "organization" || typeof type === "undefined"

  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }

  const isRequired = checkIfRequired()

  const GET_ALL_ORGANIZATIONS = gql`
    query getOrganization($staff_id: ID!) {
      organizations: getMyOrganizationsByUid(staff_id: $staff_id) {
        key: organization_id
        label: organization_name
      }
    }
  `

  const GET_ORGANIZATIONS_BY_ENTERPRISE = gql`
    query getOrganizations($staff_id: ID!, $enterprise_id: ID!) {
      organizations: organizationsByEnterpriseUid(
        staff_id: $staff_id
        enterprise_id: $enterprise_id
      ) {
        key: organization_id
        label: organization_name
      }
    }
  `

  // Select the correct query depending on the context
  const QUERY = isEnterprise
    ? GET_ORGANIZATIONS_BY_ENTERPRISE
    : GET_ALL_ORGANIZATIONS
  const queryVariables = isEnterprise
    ? {
      staff_id: userCtx.session.user.staff_id,
      enterprise_id: userCtx.session.user.enterprise_id,
    }
    : { staff_id: userCtx.session.user.staff_id }

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    if (isOrganization) {
      setDisable(true)
      const defaultValue = {
        __typename: "TypeOrganization",
        key: userCtx.session.user.organization_id,
        label: userCtx.session.user.organization_name,
      }
      formik.setFieldValue(field.field_name, defaultValue)
      setOrganizationList([defaultValue]) // Set the option in the list    
    }

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Only execute the query if we are not in organization context
  const { loading } = useQuery(QUERY, {
    fetchPolicy: "no-cache",
    variables: queryVariables,
    onCompleted: ({ organizations }) => {
      const options = _.map(organizations, ({ key, label }) => {
        return { key, label: _.unescape(label), __typename: "TypeOrganization" }
      })
      setOrganizationList(options)
    },
    skip: isOrganization || !userCtx,
  })

  if (loading) return null

  return (
    <div
      className={`${styles.field} ${typeof type === "undefined" ? styles.hidden : ""
        }`}
      style={{
        order: index,
        display: typeof type === "undefined" ? "none" : "block",
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta, form }) => (
            <>
              <Dropdown
                placeholder="Please select"
                id={field.field_name}
                name={formikField.name}
                value={formikField.value}
                onChange={formikField.onChange}
                disabled={disable}
                options={organizationList}
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </Field>
      </div>
    </div>
  )
}
